/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
import LazyLoad from 'react-lazyload';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import AdvisorConnectModule from './components/advisorConnectModule';
import CredentialCalloutGrouping from './components/credentialCalloutGrouping';
import CustomAccolades from './components/customAccolades';
import FinancialPlanningSection1 from './components/financialPlanningSection1';
import FinancialPlanningSection2 from './components/financialPlanningSection2';
import FinancialPlanningSection3 from './components/financialPlanningSection3';
import FinancialPlanningSection4 from './components/financialPlanningSection4';
import FinancialPlanningSection5 from './components/financialPlanningSection5';
import FinancialPlanningSection6 from './components/financialPlanningSection6';
import HeroSection from './components/heroSection';
import Metadata from './components/metadata';
import RelatedLinksSection from './components/relatedLinksSection';
import SuspectEmailCaptureFormSection from './components/suspectEmailCaptureFormSection';
import UnderstandingProduct from './components/understandingProduct';
// images for prefetch
import highResDesktopImage from './components/heroSection/images/who-we-are-hero.webp';
import highResMobileImage from './components/heroSection/images/who-we-are-hero-mobile.webp';
// dislaimer footnotes
import {
  HighestFinancialStrengthRatings,
  LoyaltyBasedOnClientData,
  RankingNmInvestmentsServices,
} from '../../utils/disclaimerFootnotes/disclaimerFootnotes';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();
  // We don't want to load recaptcha on page load (for performance reasons) so we will load it once the in page lead for is engaged with
  const [loadRecaptcha, setLoadRecaptcha] = useState(false);

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      config={config}
      dynamicConfig={dynamicConfig}
      useReCaptcha={loadRecaptcha}
      disclaimerFootnotes={[
        <>
          <sup>1</sup>&nbsp;Assessing the Value of a Holistic Advisor, Dr. Hal Hershfield. In Hal Hershfield&#39;s research, a comprehensive approach to planning means a client has permanent life insurance, either investments or annuities, and a recent financial plan.
        </>,
        <>
          {HighestFinancialStrengthRatings(2)}
        </>,
        <>
          <sup>3</sup>&nbsp;Expected 2025 total dividend payout.
        </>,
        <>
          <sup>4</sup>&nbsp;Decisions with respect to the determination and allocation of divisible surplus are left to the discretion and sound business judgment of the company&#39;s Board of Trustees. There is no guaranteed specific method or formula for the determination or allocation of divisible surplus. Accordingly, the company&#39;s approach is subject to change. Neither the existence nor the amount of a dividend is guaranteed on any policy in any given policy year.
        </>,
        <>
          <sup>5</sup>&nbsp;Based on historical total dividend payouts of major life insurers, 2012&#8211;2020.
        </>,
        <>
          {LoyaltyBasedOnClientData(6)}
        </>,
        <>
          {RankingNmInvestmentsServices(7)}
        </>,
      ]}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'About us',
          linkUrl: '/who-we-are/',
          linkAriaLabel: 'Northwestern Mutual Who We Are',
        },
      ]}>

      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection />

      <UnderstandingProduct />

      {/* SUSPECT EMAIL CAPTURE FORM SECTION */}
      <LazyLoad
        offset={300}
        height={300}
        once
        placeholder={
          <section id='who-we-are-page-suspect-email-capture-form'>
            <h2>Get weekly emails to help you reach your goals, big or small.</h2>
          </section>
        }>
        <SuspectEmailCaptureFormSection
          config={config}
          loadRecaptcha={loadRecaptcha}
          setLoadRecaptcha={setLoadRecaptcha}
        />
      </LazyLoad>

      <CredentialCalloutGrouping />

      <FinancialPlanningSection1 />

      <FinancialPlanningSection2 />

      <CustomAccolades />

      <FinancialPlanningSection3 />

      <FinancialPlanningSection4 />

      <FinancialPlanningSection5 />

      <FinancialPlanningSection6 />

      <AdvisorConnectModule />

      <RelatedLinksSection />

    </Page>
  );
};
